import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';

@Component({
  selector: 'app-legitimate-interest-selector',
  templateUrl: './legitimate-interest-selector.component.html',
  styleUrls: ['./legitimate-interest-selector.component.css']
})
export class LegitimateInterestSelectorComponent {
  @Input() selectedValue: string = 'init';
  @Output() selectedValueChange = new EventEmitter<string>();
  @Output() selectionChanged = new EventEmitter<Event>();
  @ViewChild('interest') interestRef: any;

  /**
   * Handles changes to the selection input
   *
   * @param event Event triggered by the selection change
   */
  public onSelectionChange(event: Event): void {
    this.selectionChanged.emit(event);
    this.selectedValueChange.emit(this.selectedValue);
  }
}
